import React, { lazy, Suspense, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import General from "../Layouts/general";

import TopLoader from "../Preload/TopLoad";

import { useDispatch, useSelector } from "react-redux";
import { fetchGeneralPage } from "../Redux/slice/homeSlice";
import Home from "../GuestPages/Home";
import About from "../GuestPages/About";
import Services from "../GuestPages/Service";
import ServicesDetails from "../GuestPages/ServiceDetails";
import Insights from "../GuestPages/Insight";
import InsightsDetails from "../GuestPages/InsightDetails";
import Testimonials from "../GuestPages/Testimonial";
import Contact from "../GuestPages/Contact";

export default function Routers() {
  const dispatch = useDispatch();

  return (
    <Suspense fallback={<TopLoader />}>
      {useRoutes([
        {
          path: "/",
          element: <General />,
          children: [
            { path: "/", element: <Home /> },
            { path: "/about", element: <About /> },
            { path: "/services", element: <Services /> },
            { path: "/services/details/:id", element: <ServicesDetails /> },
            { path: "/insights", element: <Insights /> },
            { path: "/contact", element: <Contact /> },
            { path: "/testimonials", element: <Testimonials /> },
            { path: "/insights/details/:id", element: <InsightsDetails /> },
          ],
        },
      ])}
    </Suspense>
  );
}
